<template>
  <div class="mb-24">
    <div class="mt-16 p-8 md:flex align-top">
      <div class="md:hidden mb-6">
        <h3 class="mb-6"><BaseCircle class="inline mr-1 mb-1 h-6" /><span v-html="getFieldByLang(event, 'title', lang)" /></h3>
      </div>
      <div class="mr-6 inline-block tracking-wide">
        {{ formatDate(event.date) }}
        <div class="mt-3" v-if="!event.day">
          <div class="flex items-center flex-col f-lining">
            <div class="mr-auto">
              {{ event.time_start }}
              <BaseArrowDown class="mx-auto my-2" />
              {{ event.time_end }}
            </div>
          </div>
        </div>
      </div>
      <div class="hidden md:block">
        <div class="mb-6" v-if="event.day">
          <h3 class="mb-6"><BaseCircle class="inline mr-2 mb-1 h-6" /> <span class="inline" v-html="getFieldByLang(event, 'description', lang)" /></h3>
          <div class="header-styled mb-6" v-html="getFieldByLang(event, 'long_description', lang)" />
          <ul>
            <li v-for="(event, count) in event.events" class="pb-6 md:pr-6 leading-snug" :key="count">
              <router-link class="inline-block" :to="`/${prefix}/${event.slug}`">
                <span class="tracking-wide">{{ event.time_start }} - {{ event.time_end }}</span><br/>
                {{ getFieldByLang(event, 'title', lang) }}
              </router-link><br/>
              <event-tags :event="event" />
            </li>
          </ul>
        </div>
        <div class="mb-6" v-else>
          <h3><BaseCircle class="inline mr-2 mb-1 h-6" /> <span class="inline" v-html="getFieldByLang(event, 'title', this.lang)" /></h3>
          <event-tags :event="event" />
          <div v-html="getFieldByLang(event, 'description', lang)" />
        </div>
      </div>
      <div class="md:hidden mb-6" v-html="getFieldByLang(event, 'description', lang)" />
      <div class="md:hidden mb-6 header-styled" v-html="getFieldByLang(event, 'long_description', lang)" />
      <div v-if="event.day" class="md:hidden">
        <ul>
          <li v-for="(event, count) in event.events" class="pb-6 md:pr-6 leading-snug" :key="count">
            <router-link class="inline-block" :to="`/${prefix}/${event.slug}`">
              <span class="tracking-wide">{{ event.time_start }} - {{ event.time_end }}</span><br/>
              {{ getFieldByLang(event, 'title', lang) }}
            </router-link><br/>
            <event-tags :event="event" />
          </li>
        </ul>
      </div>
    </div>
    <div class="p-8" v-if="videos">
      <h3 class="border-b border-black mt-12 mb-6 pb-3">Videos</h3>
      <div v-for="(video, count) in videos" :key="count">
        <BaseResponsiveEmbed :url="video.url" />
      </div>
    </div>
    <BaseResources class="p-8" v-if="event.resources && event.resources.length" :resources="event.resources" />
    <BaseRelated v-if="event.artists.length" class="p-8" heading="Related Artists" :items="event.artists" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import EventTags from '@/components/EventTags'
export default {

  name: 'EventDetail',

  components: { EventTags },

  data () {
    return {

    }
  },

  props: ['event', 'prefix'],
  computed: {
    ...mapState(['lang', 'cats']),
    videos () {
      if (this.event.videos.length) {
        return this.event.videos
      } else {
        return false
      }
    },
  },
  methods: {

  }
}
</script>

<style lang="stylus" scoped>
  .inline >>> p
    display: inline

  >>>p+p
    margin-top: 1em
</style>
